import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Compass, Loader2, Eye, EyeOff } from 'lucide-react';

const api = axios.create({ baseURL: '/api/sc-portal' });

export default function ScPortalAccept() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error('Passwords do not match');
    setBusy(true);
    try {
      await api.post('/accept', { token, password: pw });
      toast.success('Password set — please sign in');
      navigate('/sc-portal/login', { replace: true });
    } catch (err) { toast.error(err.response?.data?.message || 'Could not set your password'); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-6">
          <span className="h-12 w-12 rounded-2xl bg-indigo-600 text-white flex items-center justify-center mb-3"><Compass size={24} /></span>
          <h1 className="text-xl font-bold text-slate-800">Set up your access</h1>
          <p className="text-sm text-slate-400">Create a password to view your support coordination</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6 space-y-4">
          <div>
            <label className="block text-xs font-semibold text-slate-500 mb-1">New password</label>
            <div className="relative">
              <input type={show ? 'text' : 'password'} required value={pw} onChange={(e) => setPw(e.target.value)} className="w-full px-3 py-2 pr-10 rounded-lg border border-slate-200 text-sm focus:border-slate-400 focus:ring-0" placeholder="At least 8 characters" />
              <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-2.5 top-2.5 text-slate-400">{show ? <EyeOff size={17} /> : <Eye size={17} />}</button>
            </div>
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-500 mb-1">Confirm password</label>
            <input type={show ? 'text' : 'password'} required value={pw2} onChange={(e) => setPw2(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-slate-200 text-sm focus:border-slate-400 focus:ring-0" />
          </div>
          <button type="submit" disabled={busy} className="w-full py-2.5 rounded-xl bg-indigo-600 text-white font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
            {busy ? <Loader2 size={17} className="animate-spin" /> : null}Set password
          </button>
        </form>
        <p className="text-center text-xs text-slate-300 mt-4">Powered by Rostery</p>
      </div>
    </div>
  );
}
